import React from 'react';
import { Link } from 'react-router-dom';
import { EVENTS } from '@/constants/testIds';
import { Calendar, MapPin, Ticket } from 'lucide-react';

const monthLabel = (d) => {
  try {
    const dt = new Date(d);
    return { day: dt.getDate(), month: dt.toLocaleString('en', { month: 'short' }) };
  } catch {
    return { day: '—', month: '—' };
  }
};

const EventCard = ({ event }) => {
  const { day, month } = monthLabel(event.event_date);
  return (
    <Link
      to={`/events/${event.event_id}`}
      data-testid={EVENTS.card}
      className="group flex flex-col sm:flex-row gap-5 rounded-2xl border border-white/10 bg-[#13182C] overflow-hidden card-glow"
    >
      <div className="sm:w-56 h-44 sm:h-auto relative shrink-0">
        <img src={event.cover_image} alt={event.title} className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" loading="lazy" />
        <div className="absolute inset-0 bg-gradient-to-r from-[#0B1020]/40 to-transparent" />
      </div>
      <div className="flex-1 p-5 flex gap-5">
        <div className="shrink-0 text-center px-4 py-3 rounded-xl bg-fuchsia-500/15 text-fuchsia-300 self-start">
          <div className="font-display text-3xl font-bold leading-none">{day}</div>
          <div className="text-xs uppercase tracking-wider mt-1">{month}</div>
        </div>
        <div className="flex-1 min-w-0">
          <div className="text-[11px] uppercase tracking-widest text-cyan-300 mb-1">{event.category || 'Event'}</div>
          <h3 className="font-display text-xl text-white font-semibold mb-2 truncate">{event.title}</h3>
          <div className="flex items-center gap-4 text-xs text-slate-400 mb-3">
            <span className="flex items-center gap-1"><Calendar className="h-3.5 w-3.5" />{event.event_date}</span>
            <span className="flex items-center gap-1"><MapPin className="h-3.5 w-3.5" />{event.venue}, {event.city}</span>
          </div>
          <p className="text-sm text-slate-400 line-clamp-2">{event.description}</p>
          <div className="mt-3 flex items-center gap-2 text-sm">
            <Ticket className="h-4 w-4 text-amber-300" />
            <span className="text-white font-medium">
              {event.ticket_price ? `₹${event.ticket_price.toLocaleString('en-IN')}` : 'Free'}
            </span>
          </div>
        </div>
      </div>
    </Link>
  );
};

export default EventCard;
